import { SvgProps } from "components/icons/types";

export const CalendarWithClockIcon = (props: SvgProps) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_7473_6990)">
        <path
          d="M8.5 5C6.5705 5 5 6.57 5 8.5C5 10.43 6.5705 12 8.5 12C10.4295 12 12 10.43 12 8.5C12 6.57 10.4295 5 8.5 5ZM8.5 11C7.1215 11 6 9.8785 6 8.5C6 7.1215 7.1215 6 8.5 6C9.8785 6 11 7.1215 11 8.5C11 9.8785 9.8785 11 8.5 11ZM9 8.293L9.8535 9.1465L9.1465 9.8535L8 8.707V7H9V8.293ZM12 2.5V5.6745C11.7155 5.3225 11.3765 5.0185 11 4.7655V2.5C11 2.2245 10.776 2 10.5 2H1.5C1.2245 2 1 2.2245 1 2.5V4H8.5C7.429 4 6.447 4.3755 5.6745 5H1V11H4.759C5.012 11.378 5.3215 11.7145 5.6745 12H0V2.5C0 1.673 0.673 1 1.5 1H3V0H4V1H8V0H9V1H10.5C11.327 1 12 1.673 12 2.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_7473_6990">
          <rect width="12" height="12" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};
